import instance from '@/store/api/instance';

export let CpDashReportSub = function (data) {
    return instance.post('/cpdash/code/sub/report/mo/read', data)
}

export let CpDashReportSubExport = function (data) {
    return instance.post('/cpdash/code/sub/report/mo/export', data)
}